/* __next_internal_client_entry_do_not_use__ Square auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/** @trackcomponent */ export var Square = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 4 0 C 1.7908 0 0 1.7908 0 4 V 20 C 0 22.2092 1.7908 24 4 24 H 20 C 22.2092 24 24 22.2092 24 20 V 4 C 24 1.7908 22.2092 0 20 0 H 4 Z M 5.6744 4.4744 C 5.012 4.4744 4.4744 5.012 4.4744 5.6744 V 18.3256 C 4.4744 18.988 5.012 19.5256 5.6744 19.5256 H 18.3256 C 18.988 19.5256 19.5256 18.988 19.5256 18.3256 V 5.6744 C 19.5256 5.012 18.988 4.4744 18.3256 4.4744 H 5.6744 Z",
            fill: "#333333"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M 9.3424 8.9492 L 14.2508 8.9492 A 0.8 0.8 90 0 1 15.0508 9.7492 L 15.0508 14.6576 A 0.8 0.8 90 0 1 14.2508 15.4576 L 9.3424 15.4576 A 0.8 0.8 90 0 1 8.5424 14.6576 L 8.5424 9.7492 A 0.8 0.8 90 0 1 9.3424 8.9492 Z",
            fill: "#333333"
        })
    ]
}), "Square", {
    viewBox: "0 0 24 24",
    fill: "none"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
